import React, { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Link } from "react-router-dom";
import { catalogRoleClean, cleanSearchingCatalogRolesPaginated } from "../../app/actions/catalogRoleActions";

import ReactTooltip from "react-tooltip";
import { useTracking } from "react-tracking";
import { useTranslation } from "react-i18next";
import DisplayNameAndRole from "./DisplayNameAndRole";

const NavbarIconsCatalogRoles = ({ page }) => {
  const dispatch = useDispatch();
  const { trackEvent } = useTracking();
  const { t } = useTranslation();

    const { isUserAuthenticated } = useSelector((state) => state.auth);

  const [activeIcon, setActiveIcon] = useState(null);

  const handleActiveIcon = (icon) => {
    
    if (icon === "new") {
      
      trackEvent({ component: "NewCatalogRoles", event: "NewCatalogRoles-Clicked" });
    } else if (icon === "list") {
      
      trackEvent({ component: "ListCatalogRoles", event: "ListCatalogRoles-Clicked" });
       dispatch(cleanSearchingCatalogRolesPaginated());
    }

    dispatch(catalogRoleClean());
    setActiveIcon(icon);
  };

  const iconActiveStyle = (icon) => {
    if (activeIcon === icon) {
      return "icon-d-flex active";
    } else {
      return "icon-d-flex";
    }
  };

  return (
   <div className="d-flex justify-content-between align-items-center flex-nowrap gradient-custom-sky custom-nav-height">
      {isUserAuthenticated && (
        <DisplayNameAndRole />
      )}
      {page === "listCatalogRoles" && (
        <Link
          data-tip
          data-for="newCatalogRolesTip"
          to="/admin-catalog-role/new-catalog-role"
          className="p-2 bd-highlight"
          onClick={() => handleActiveIcon("new")}
        >
          <i className={`fa fa-plus-square fa-2x ${iconActiveStyle("new")}`} aria-hidden="true" />
        </Link>
      )}
      {page === "newCatalogRoles" && (
        <Link
          data-tip
          data-for="listCatalogRolesTip"
          to="/admin-catalog-role/"
          className="p-2 bd-highlight"
          onClick={() => handleActiveIcon("list")}
        >
          <i className={`fa fa-table fa-2x ${iconActiveStyle("list")}`} aria-hidden="true" />
        </Link>
      )}
      {page === "editCatalogRoles" && (
        <div className="navbar-module-actions">
          <Link
            data-tip
            data-for="listCatalogRolesTip"
            to="/admin-catalog-role/"
            className="p-2 bd-highlight"
            onClick={() => handleActiveIcon("list")}
          >
            <i className={`fa fa-table fa-2x ${iconActiveStyle("list")}`} aria-hidden="true" />
          </Link>
          <Link
            data-tip
            data-for="newCatalogRolesTip"
            to="/admin-catalog-role/new-catalog-role"
            className="p-2 bd-highlight"
            onClick={() => handleActiveIcon("new")}
          >
            <i className={`fa fa-plus-square fa-2x ${iconActiveStyle("new")}`} aria-hidden="true" />
          </Link>
        </div>
      )}

      <ReactTooltip id="newCatalogRolesTip" place="left" effect="solid">
        {t("admin-catalog-role.page.register")}
      </ReactTooltip>
      <ReactTooltip id="listCatalogRolesTip" place="left" effect="solid">
        {t("admin-catalog-role.page.list")}
      </ReactTooltip>
    </div>
  );
};

export default NavbarIconsCatalogRoles;
